import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lkd-marketing',
  templateUrl: './marketing.component.html',
  styles: []
})
export class MarketingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
